import React, { useContext, useEffect, useState } from 'react';
import { WidthProvider, Responsive } from 'react-grid-layout';
import PropTypes from 'prop-types';

import DashboardContext from '#/context';
import Widget from '#/components/Widget';
import FilterButton from '#/components/FilterButton';
import { ReactComponent as ConfigIcon } from '#/assets/icons/config.svg';
import EmptyContainer from '#/components/EmptyContainer';
import WidgetFilter from '#/components/WidgetFilter';
import Modal from '#/components/Modal';
import './react-grid-layout.css';
import styles from './styles.module.css';

import {useTabs} from '#/contexts/tabscontexts';
const ResponsiveReactGridLayout = WidthProvider(Responsive);

function Dashboard() {
  const [ modal, setModal ] = useState(null);

  const {
    widgets,
    activeDashboard,
    setActiveDashboard,
    tempDashboard,
    setTempDashboard,
    stateDashboard,
  } = useContext(DashboardContext);

  const {activeTabIndex} = useTabs();

  useEffect(() => {
    const temp = tempDashboard;
    const active = activeDashboard;
    setActiveDashboard([]);
    setTempDashboard([]);
    setTimeout(() => setActiveDashboard(active));
    setTimeout(() => setTempDashboard(temp));
  }, [activeTabIndex]);

  function handleDrop(e) {
    const currentDash =
      tempDashboard[activeTabIndex] || activeDashboard[activeTabIndex];
    const currentWidget = widgets.find(
      widget => e.dataTransfer.getData('Text') === widget.i
    );
    const newTempDashboard = tempDashboard.map(dash => {
      const currentOrdination = (currentDash && currentDash.ordination) || 0;
      if (dash.ordination === currentOrdination) {
        return {
          ...dash,
          widgets: [
            ...(dash.widgets || []),
            {
              ...currentWidget,
              w: currentWidget.w || currentWidget.minW,
              h: currentWidget.h || currentWidget.minH,
              x: currentWidget.x || 0,
              y: currentWidget.y || Infinity,
            },
          ],
        };
      }
      return dash;
    });

    if(newTempDashboard && newTempDashboard.length > 0) {
      newTempDashboard.forEach(dash => {
        if(dash.widgets && dash.widgets.length > 0) {
          dash.widgets.forEach((w, index) => {
            w.tmpKey = `${w.i}${new Date().getTime()}${index}`;
          });
        }
      })
    }
    setTempDashboard(newTempDashboard);
  }

  function handleClose(index) {
    const temp = tempDashboard[activeTabIndex];
    const newWidgets = temp.widgets.filter(({ tmpKey }) => {
      return index !== tmpKey;
    });
    const newDashboard = tempDashboard.map(dashboard => {
      if (dashboard.id === temp.id)
        return {
          ...temp,
          widgets: [...newWidgets],
        };
      return dashboard;
    });    
    setTempDashboard(newDashboard);
  }

  function onLayoutChange(layout) {
    const currentDashboard = tempDashboard[activeTabIndex];
    const newLayout = layout.map((currentLayout, index) => {
      return {
        ...currentDashboard.widgets[index],
        w: currentLayout.w || currentLayout.minW,
        h: currentLayout.h || currentLayout.minH,
        x: currentLayout.x || 0,
        y: currentLayout.y || 0,
      };
    });
    const newDashboard = tempDashboard.map(dashboard => {
      if (dashboard.ordination === currentDashboard.ordination)
        return {
          ...currentDashboard,
          widgets: [...newLayout],
        };
      return dashboard;
    });
    setTempDashboard(newDashboard);
  }

  function renderWidgets() {
    const active =
      (activeDashboard[activeTabIndex] &&
        activeDashboard[activeTabIndex].widgets) ||
      [];
    const temp =
      (tempDashboard[activeTabIndex] &&
        tempDashboard[activeTabIndex].widgets) ||
      [];
    const arrayDashboard = stateDashboard.edit ? [...temp] : [...active];
    
    return arrayDashboard.map((widget, index) => {
      if(!widget.tmpKey)
        widget.tmpKey = `${widget.i}${new Date().getTime()}${index}`;
      return (widget ? createWidget(widget) : [])
    });
  }

  function saveWidgetFilter() {
    setModal(null);
  }


  function createWidgetFilter(widget) {
    setModal(
      <WidgetFilter
        widget={widget}
        callBack={saveWidgetFilter}
      />
    )
  }

  

  function createWidget(widget) {
    return (
      <div key={widget.dashboardWidgetId ? widget.dashboardWidgetId : widget.tmpKey} datakey={widget.i} data-grid={widget} style={{overflow: 'visible'}}>
        <div className={[!stateDashboard.edit ? styles.hide : '',].join(' ')}>
          <FilterButton toggle={() => createWidgetFilter(widget)} customStyleClass={styles.filter} sizeIcon={15} bgColor='transparent' Icon={ConfigIcon} styleIcon={{
            fill: '#9e9e9e'
          }}/>
          <span
            className={styles.close}
            data-testid="close-button"
            onClick={e => handleClose(widget.tmpKey, e)}
          />
        </div>
        <Widget data={widget}/>
      </div>
    );
  }

  const canShowDashboard = () => {
    const active =
      (activeDashboard[activeTabIndex] &&
        activeDashboard[activeTabIndex].widgets) ||
      [];
    const temp =
      (tempDashboard[activeTabIndex] &&
        tempDashboard[activeTabIndex].widgets) ||
      [];
    return active.length || temp.length || stateDashboard.edit;
  };

  return (
    <React.Fragment>
      <Modal
        isOpen={modal !== null && modal !== undefined}
        title={null}
        hideBtnClose={true}
        noPadding={true}
        noMargin={true}
        onClose={() => setModal(null)}
      >
        {modal}
      </Modal>
      {canShowDashboard() ? (
        <div onDrop={handleDrop} onDragOver={event => event.preventDefault()}>
          <ResponsiveReactGridLayout
            className={stateDashboard.edit ? styles.editable : ''}
            rowHeight={100}
            cols={{ lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 }}
            isDraggable={stateDashboard.edit}
            isResizable={stateDashboard.edit}
            onLayoutChange={layout =>
              stateDashboard.edit && onLayoutChange([...layout])
            }
          >
            {renderWidgets()}
          </ResponsiveReactGridLayout>
        </div>
      ) : (
        <EmptyContainer />
      )}
    </React.Fragment>
  );
}

Dashboard.propTypes = {
  activeTabIndex: PropTypes.number.isRequired,
};

Dashboard.defaultProps = {
  activeTabIndex: 0,
};

export default Dashboard;
